import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { createUseStyles } from '@glu/theming';
import { DragAshIcon } from '@glu/icons-react';
import { AccessibilityText } from '@glu/utilities-react';
import locale from '@glu/locale';
import styles from './ResizeHandle.styles';

const useStyles = createUseStyles(styles);

const ResizeHandle = (props) => {
  const classes = useStyles(props);
  const {
    cardElem,
    minHeight,
    minWidth,
    onResize,
    setResizedHeight,
    setResizedWidth
  } = props;
  const [dragging, setDragging] = useState(false);
  const [startDragPosX, setStartDragPosX] = useState();
  const [startDragPosY, setStartDragPosY] = useState();

  const handleMouseDown = ({ clientX, clientY }) => {
    setDragging(true);
    setStartDragPosX(clientX);
    setStartDragPosY(clientY);
  };

  const handleMouseUp = () => {
    setDragging(false);
  };

  const handleMouseMove = ({ clientX, clientY }) => {
    if (dragging) {
      const { width, height } = cardElem.current.getBoundingClientRect();
      const newWidth = width + (clientX - startDragPosX);
      const newHeight = height + (clientY - startDragPosY);

      if (newWidth > minWidth) {
        setStartDragPosX(clientX);
      }
      if (newHeight > minHeight) {
        setStartDragPosY(clientY);
      }

      const resizedWidth = newWidth > minWidth ? newWidth : minWidth;
      const resizedHeight = newHeight > minHeight ? newHeight : minHeight;
      setResizedWidth(resizedWidth);
      setResizedHeight(resizedHeight);

      onResize({ width: resizedWidth, height: resizedHeight });
    }
  };

  useEffect(() => {
    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('mouseup', handleMouseUp);
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    };
  }, [handleMouseMove, handleMouseUp]);

  return (
    <button
      className={classes.root}
      type="button"
      onMouseDown={handleMouseDown}
    >
      <AccessibilityText>{locale.get('resizeHandle')}</AccessibilityText>
      <DragAshIcon />
      <span className={classes.grip} />
    </button>
  );
};

ResizeHandle.propTypes = {
  cardElem: PropTypes.shape({
    current: PropTypes.shape({
      getBoundingClientRect: PropTypes.func
    })
  }).isRequired,
  minHeight: PropTypes.number.isRequired,
  minWidth: PropTypes.number.isRequired,
  onResize: PropTypes.func.isRequired,
  setResizedHeight: PropTypes.func.isRequired,
  setResizedWidth: PropTypes.func.isRequired
};

export default ResizeHandle;
